import React from "react";

export const Services = (props) => {
  return (
    <section id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <span className="section-kicker">WHAT WE DO</span>
          <h2>Our Services</h2>
          <p>
            Practical technology services to help turn your next idea into something real.
          </p>
        </div>
        <div className="row services-grid">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4">
                  <article className={`service-card service-card-${i + 1}`}>
                    <div className="service-card-top">
                      <span className="service-icon"><i className={d.icon} aria-hidden="true"></i></span>
                      <span className="service-index">0{i + 1}</span>
                    </div>
                    <div className="service-desc">
                      <h3>{d.name}</h3>
                      <p>{d.text}</p>
                    </div>
                    <a className="service-link page-scroll" href="#contact" aria-label={`Discuss ${d.name}`}>
                      <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </a>
                  </article>
                </div>
              ))
            : "Loading services..."}
        </div>
      </div>
    </section>
  );
};
